// durationSpan.js — how many whole calendar days a duration occupies.
//
// One owner for a rule the client previously had four copies of:
//   calendar.jsx:851             Math.max(Math.ceil(d || 1), 1)   correct
//   requestimateForm.jsx:425     Math.max(1, Math.round(d))       due date
//   requestimates.jsx:2045       parseInt(d) || 1                 TRUNCATED
//   editJob.jsx:230              add(d, 'days') raw               due date
//
// parseInt booked a 1.7-day job for one calendar day while the calendar drew
// two. 523 of 829 production requests with a duration (63%) were affected.
//
// Zero imports: scripts/test/durationSpan.test.mjs loads this directly.

/**
 * @param {number|string|null} duration  decimal days
 * @returns {number}  whole calendar days, minimum 1
 */
export function calendarDaySpan(duration) {
  const n = Number(duration);
  if (!Number.isFinite(n) || n <= 0) return 1;
  return Math.max(Math.ceil(Number(n.toFixed(10))), 1);
}
